import { LocalTime } from 'js-joda';
import clsx from 'clsx';

import { DisplayTime } from '@tock/time';
import { IWithContextProps, withContext } from '@tock/coretypes';
import { IconChevronDown } from '@tock/icons';
import { TimeValueOption } from 'types';
import { Typography } from 'omakase';
import { css } from '@emotion/react';
import BaseComponent from '@tock/shared/components/BaseComponent';
import Input from '@tock/shared/components/inputs/Input';
import InputContainer from '@tock/shared/components/forms/InputContainer';

interface Props {
  displayedTimes: TimeValueOption[];
  onSelectTime(time: string): void;
  rotateArrow?: boolean;
  selectedTime: LocalTime;
  timeClassName: string;
  locale?: string;
}

interface State {
  isActive: boolean;
}

class SearchBarTimeSection extends BaseComponent<Props & IWithContextProps, State> {
  constructor(props: Props & IWithContextProps) {
    super(props);
    this.state = {
      isActive: false,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSelectTime(event: any) {
    const viewValue = event.target.value;
    this.props.onSelectTime(viewValue);
  }

  handleFocus() {
    this.setState({
      isActive: true,
    });
  }

  handleBlur() {
    this.setState({
      isActive: false,
    });
  }

  render() {
    const { displayedTimes, selectedTime, timeClassName, locale } = this.props;

    const searchBarClassName = clsx('Dropdown-section', {
      'is-active': this.state.isActive,
    });
    const fakeField = {
      onBlur: this.handleBlur,
      onChange: this.handleSelectTime,
      value: selectedTime.toString(),
    };

    return (
      <InputContainer
        className={clsx(timeClassName, searchBarClassName)}
        data-testid="reservation-search-time-container"
      >
        <Input
          {...this.props}
          classNames={clsx('Select-input', 'Dropdown-section--select')}
          data-testid="reservation-search-time"
          options={displayedTimes}
          type="select"
          placeholder="Desired reservation time"
          value={selectedTime.toString()}
          field={fakeField}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />

        <div
          className="SearchBar-sectionDropdown SearchBar-sectionDropdown--sakePadding"
          aria-hidden="true"
        >
          <div className="SearchBar-sectionDropdownContent">
            <div
              css={css`
                align-items: flex-start;
                display: flex;
                flex-direction: column;
              `}
            >
              <Typography variant="caption" color="fgSubtle">
                Time
              </Typography>
              <Typography variant="body02" color="fgDefault" data-testid="Select-text">
                <DisplayTime timeValue={selectedTime} localeFromProps={locale} />
              </Typography>
            </div>
          </div>
          <IconChevronDown />
        </div>
      </InputContainer>
    );
  }
}

export default withContext(SearchBarTimeSection);
